export enum GlossaryStatusEnum {
  CREATED = 0,
  PROCESSING = 1,
  PROCESSED = 2
}

export type GlossaryStatus =
  | GlossaryStatusEnum.CREATED
  | GlossaryStatusEnum.PROCESSING
  | GlossaryStatusEnum.PROCESSED;
